import { QueryFunctionContext } from '@tanstack/react-query';
import { getTTSVoiceParams, TTSVoice } from './telnyx.types';
import { baseClient } from '@store/index';

export const getTTSVoices = async ({ queryKey }: QueryFunctionContext<[string, getTTSVoiceParams]>) => {
  const [, { provider, elevenlabs_api_key_ref = undefined }] = queryKey;

  const url = elevenlabs_api_key_ref
    ? `/telnyx/voices/${provider}?elevenlabs_api_key_ref=${elevenlabs_api_key_ref}`
    : `/telnyx/voices/${provider}`;

  const response = await baseClient.get<TTSVoice[]>(url);
  return response.data;
};
